import { Controller } from 'stimulus'
import { currentHeaderObject } from './object_panel_context'

const WIDGET = '[data-controller~="help-desks--widget"]'

export default class extends Controller {
  static values = { assistant: Boolean, object: Object }

  closeSidePanelIfOpen(e) {
    if (this.assistantValue && document.querySelector(WIDGET)) {
      this.#openAssistant(e)
      return
    }

    const object = currentHeaderObject()
    const url = new URL(this.element.href, window.location.origin)
    for (const key of ['signed_object_gid', 'object_account_id'])
      url.searchParams.delete(key)
    if (object) {
      url.searchParams.set('signed_object_gid', object.signed_gid)
      url.searchParams.set('object_account_id', object.account_id)
    }
    this.element.href = url.toString()
    const chatBotSidePanel = document.querySelector('.js-chat-bot-side-panel')
    if (chatBotSidePanel && chatBotSidePanel.closest('.open')) {
      this.dispatch('hide', {
        target: chatBotSidePanel,
        prefix: false,
        bubbles: true,
      })
      e.preventDefault()
      e.stopPropagation()
    }
  }

  #openAssistant(e) {
    e.preventDefault()
    e.stopPropagation()
    const object = this.hasObjectValue
      ? this.objectValue
      : currentHeaderObject()
    document.dispatchEvent(
      object
        ? new CustomEvent('help-desk:object', { detail: { object } })
        : new CustomEvent('help-desk:open', { detail: { tab: 'home' } })
    )
  }
}
